import { PriceAndCurrencyField } from 'form';
import { Grid, Typography } from 'ui';

export const RevenuesSection = () => {
  return (
    <>
      <Typography variant="h5">Revenues</Typography>
      <Grid container spacing={4}>
        <Grid item xs={12} md={3}>
          <PriceAndCurrencyField
            label="Purchaser price /t"
            priceName="buyer_price_per_tonne"
            currencyName="buyer_currency"
            required
          />
        </Grid>
        <Grid item xs={12} md={3}>
          <PriceAndCurrencyField
            label="PERN revenue /t"
            priceName="pern_revenue_per_tonne"
            currencyName="pern_currency"
          />
        </Grid>
      </Grid>
    </>
  );
};
